@use '../../styles/variables.scss';
.status-icon {
  &--complete {
    //color: $in--green-200;
  }
  &--in-progress {
    //color: $in--blue-100;
  }
  &--pending {
    //color: $in--black-25;
  }
  &--error {
    //color: $in--red-100;
  }
  &--inherit-line-height {
    line-height: inherit;
  }
}
